import React from "react";
import { connect } from "react-redux";

import campaignResultDefaultImg from '../../../assets/images/campaignResult-default.png';
import './apiLogResult.css';
import LeftArrowImg from '../../../assets/images/left-arrow.png';
import RightArrowImg from '../../../assets/images/right-arrow.png';
import ShowJson from "../ShowJson";

export class ApiLogResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            selectedLogData: null // To store the JSON data for ShowJson
        }
    }

    getApiLogData = () => {
        let sortedArray = this.props.apiLogs.slice(25 * this.state.currentPage - 25, 25 * this.state.currentPage);
        let JSX = [];

        sortedArray.forEach((entry) => {
            JSX.push(
                <tr className="ApiLogResult-value" key={entry.id}>
                    <td className="ApiLogResult-date-value">{entry.insertedon.split('.')[0].replace('T', ' ')}</td>
                    <td className="ApiLogResult-method-value">{entry.requestmethod}</td>
                    <td className="ApiLogResult-endpoint-value">{entry.methodname}</td>
                    <td>
                        <button className="show-params-button" onClick={() => this.setState({ selectedLogData: entry.inputparameters })}>
                            Show Input Params
                        </button>
                    </td>
                    <td>
                        <button className="show-params-button" onClick={() => this.setState({ selectedLogData: entry.output })}>
                            Show Output Params
                        </button>
                    </td>
                    <td className="ApiLogResult-responsecode-value">{entry.httpcode}</td>
                </tr>
            );
        });

        return JSX;
    }

    moveNextPage = () => {
        if(this.state.currentPage < this.props.maxPage){
            this.setState({ currentPage: this.state.currentPage + 1 });
        }
    }

    movePreviousPage = () => {
        if(this.state.currentPage > 1){
            this.setState({ currentPage: this.state.currentPage - 1 });
        }
    }

    conditionalRendering = () => {
        if(this.state.selectedLogData){
            return(<ShowJson jsonData={this.state.selectedLogData} onClose={() => this.setState({ selectedLogData: null })} />);
        }
        if (this.props.apiLogs) {
            return (
                <div className="ApiLogResult">
                    <div className="ApiLogResult-log-details-container">
                        <table className="ApiLogResult-log-details">
                            <thead>
                                <tr>
                                    <th className="ApiLogResult-date">Date</th>
                                    <th className="ApiLogResult-method">Method</th>
                                    <th className="ApiLogResult-endpoint">Endpoint</th>
                                    <th className="ApiLogResult-input">Input</th>
                                    <th className="ApiLogResult-output">Output</th>
                                    <th className="ApiLogResult-responsecode">Response Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.getApiLogData(this.state.currentPage)}
                            </tbody>
                        </table>
                    </div>
                    <div className="ApiLogResult-pagination">
                        <div className="ApiLogResult-pagination-count">{this.state.currentPage} of {this.props.maxPage}</div>
                        <div className="ApiLogResult-pagination-buttongroup">
                            <button className="ApiLogResult-pagination-button-previous" onClick={this.movePreviousPage}>
                                <img src={LeftArrowImg} alt="Previous" />
                            </button>
                            <button className="ApiLogResult-pagination-button-next" onClick={this.moveNextPage}>
                                <img src={RightArrowImg} alt="Next" />
                            </button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="CampaignResult-default">
                    <img src={campaignResultDefaultImg} alt="Default" />
                    <div> Let The Search Begin!</div>
                </div>
            );
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.conditionalRendering()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    if (state.logs.apiLogs.logs && state.logs.apiLogs.logs.length) {
        return { 
            apiLogs: state.logs.apiLogs.logs, 
            maxPage: state.logs.apiLogs.logs.length % 25 === 0 ? state.logs.apiLogs.logs.length / 25 : Math.ceil(state.logs.apiLogs.logs.length / 25)
        };
    } else {
        return { apiLogs: null, maxPage: 1 };
    }
};

export default connect(mapStateToProps)(ApiLogResult);
